module.exports = __webpack_public_path__ + "img/afi.ef022fe7.jpg";